import { TableStyles } from 'react-data-table-component/dist/DataTable/types'

export const tableStyles: TableStyles = {
  responsiveWrapper: {
    style: {
      overflowY: 'auto',
      maxHeight: '700px',
      '&::-webkit-scrollbar': {
        width: '12px',
        height: '12px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    },
  },
  headRow: {
    style: {
      paddingLeft: '10px',
    },
  },
  headCells: {
    style: {
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: '8px',
      paddingRight: '8px',
      "&[data-column-id='1']": {
        minWidth: '40px',
        maxWidth: '60px',
      },
    },
  },
  rows: {
    style: {
      paddingLeft: '10px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
      "&[data-column-id='1']": {
        minWidth: '40px',
        maxWidth: '60px',
      },
    },
  },
  pagination: {
    style: {
      color: 'black',
    },
    pageButtonsStyle: {
      fill: 'black',
      ':disabled': {
        fill: '#b3b3b3',
      },
    },
  },
}
